import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[toggleSideMenu]',
})
export class ToggleSideMenuDirective {
  @Input() sideMenuClass: string = 'active';
  @Input() sideMenuElement: string = '.side-menu';
  @Input() mainContent: string = '.main-wrapper';

  constructor(private elementRef: ElementRef) {}

  @HostListener('click') onClick() {
    const sideMenu = document.querySelector(this.sideMenuElement);
    const header = document.getElementById('header');
    const main = document.getElementById('main-wrapper');

    if (sideMenu) {
      sideMenu.classList.toggle(this.sideMenuClass);
      header?.classList.toggle('width-mod');
      main?.classList.toggle('width-mod');
    }
    this.hideItem();
  }

  hideItem(): void {
    const hideCollapse = document.querySelectorAll('.hide-collapse');
    hideCollapse.forEach(each => {
      if (!each.classList.contains('d-none')) {
        each.classList.add('d-none');
      } else {
        each.classList.remove('d-none');
      }
    });
  }
}
